import { render, staticRenderFns } from "./ToolbarSaveEmailAction.vue?vue&type=template&id=2311fdfa&scoped=true"
import script from "./ToolbarSaveEmailAction.vue?vue&type=script&lang=js"
export * from "./ToolbarSaveEmailAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311fdfa",
  null
  
)

export default component.exports